/**
 * Created by Vladislav on 24.09.2024.
 */
// eslint-disable-next-line
var hiddenByDefault = function () {
    return [cleverapps.Environment.SCENE_OCTOPUS_HUNT, cleverapps.Environment.SCENE_WEEKLY_TOURNAMENT];
};

const GoldMenuBarItem = {
    name: "GoldItem",
    isClickable: function () {
        return cleverapps.flags.monetization !== cleverapps.Flags.MONETIZATION_DISABLED;
    },
    clickableUpdater: function (f) {
        cleverapps.flags.on("change:monetization", f, this);
    },
    targets: "hard",
    plusButton: true,
    value: function () {
        return cleverapps.user.gold;
    },
    updater: function (f) {
        cleverapps.user.on("changeHard", f, this);
    },
    attentionUpdater: function (f) {
        cleverapps.adsLimits.on("update", f, this);
        cleverapps.eventBus.on("changePendingRestore", f, this);

        if (cleverapps.subscription) {
            cleverapps.subscription.on("update", f, this);
        }

        if (cleverapps.growthFund) {
            cleverapps.growthFund.on("updateState", f, this);
        }
    },
    sparks: true,
    attention: function () {
        // a purchase the store delivered late is waiting to be restored
        if (cleverapps.paymentsLogic.pendingPurchaseToRestore) {
            return true;
        }
        if (ShopProductSource.listProducts(ShopWindow.TABS.HARD_CURRENCY).indexOf("hardForVideo") !== -1
            && cleverapps.adsLimits.state(AdsLimits.TYPES.HARD) === AdsLimits.STATE_READY
            && (!VirtualProducts.hardForVideo.inABExperiments || VirtualProducts.hardForVideo.inABExperiments())) {
            return true;
        }
        if (ShopProductSource.listProducts(ShopWindow.TABS.HARD_CURRENCY).indexOf("subsMonth") !== -1
            && cleverapps.subscription && cleverapps.subscription.needsAttention()) {
            return true;
        }
        if (cleverapps.growthFund && cleverapps.growthFund.needsAttention()) {
            return true;
        }
        return false;
    },
    availableOnScenes: function () {
        const scenes = [
            cleverapps.Environment.SCENE_MAIN,
            cleverapps.Environment.SCENE_HEROES,
            cleverapps.Environment.SCENE_DAILY_CUP,
            cleverapps.Environment.SCENE_BONUS_WORLD,
            cleverapps.Environment.SCENE_SLOT_MACHINE,
            cleverapps.Environment.SCENE_PINBALL,
            cleverapps.Environment.SCENE_OCTOPUS_HUNT,
            cleverapps.Environment.SCENE_GAME,
            cleverapps.Environment.SCENE_WEEKLY_TOURNAMENT
        ];
        return scenes;
    },
    hiddenByDefault: hiddenByDefault(),
    icon: bundles.menubar.frames.gold_png,
    onClickWindow: () => HardCurrencyShopWindow,
    incEffect: () => cleverapps.styles.GoldMenuBarItem.incEffect,
    decEffect: () => cleverapps.styles.GoldMenuBarItem.decEffect,
    onDebugClick: function () {
        cleverapps.user.earnHard(cleverapps.EVENTS.EARN.OTHER, 100);
    }
};

cleverapps.styles.GoldMenuBarItem = {
    incEffect: "meta.coins.collect",
    decEffect: "meta.coins.collect"
};
